import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import api from '~/services/api';
import IconAvatarChat from '~/assets/icones/IconAvatarChat.svg';
import {
  Container,
  Section,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  CardsGrid,
  ComunicadoCard,
  DestaqueBadge,
  ComunicadoItem,
  ComunicadosList,
  DateInfo,
  ItemContent,
  ItemDescription,
  ItemFooter,
  ItemHeader,
  ItemTitle,
  SectionTitle,
  TitleDot,
  Header,
  HeaderTitle,
  HeaderDate,
  SectionHeaderRow,
  CakeIcon,
  UnreadIndicator,
  ComunicadoItemContainer,
  SkeletonCard,
  SkeletonItem,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalButton,
  DownloadButton,
  FilePreview,
  FilePreviewIcon,
  FilePreviewInfo,
  FilePreviewName,
  FilePreviewSize,
} from './styles';
import sistemaStore from '~/pages/Sistema/sistemaStore';
import { Colors } from '~/config/Colors';

Modal.setAppElement('#root');

export default function Home() {
  const { usuario } = useSelector(state => state.auth);
  const { setHasUnreadComunicados } = React.useContext(sistemaStore);
  const [birthdaysToday, setBirthdaysToday] = useState([]);
  const [modalVisualizar, setModalVisualizar] = useState(false);
  const [comunicadoSelecionado, setComunicadoSelecionado] = useState(null);
  const [comunicadosDestaque, setComunicadosDestaque] = useState([]);
  const [todosComunicados, setTodosComunicados] = useState([]);
  const [loading, setLoading] = useState(true);

  const firstName = React.useMemo(() => {
    const nome = usuario?.nome || usuario?.name || '';
    const parts = nome.trim().split(' ').filter(Boolean);
    return parts[0] || 'Bem-vindo';
  }, [usuario]);

  const saudacao = React.useMemo(() => {
    const agora = new Date();
    const hora = agora.getHours();

    if (hora >= 5 && hora < 12) {
      return 'Bom dia';
    } else if (hora >= 12 && hora < 18) {
      return 'Boa tarde';
    } else {
      return 'Boa noite';
    }
  }, []);

  const hojeStr = React.useMemo(() => {
    try {
      const opts = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
      const s = new Date().toLocaleDateString('pt-BR', opts);
      return s.charAt(0).toUpperCase() + s.slice(1);
    } catch (e) {
      return new Date().toLocaleDateString('pt-BR');
    }
  }, []);

  useEffect(() => {
    async function loadAniversariantes() {
      const hoje = new Date();
      const hojeDia = hoje.getDate();
      const hojeMes = hoje.getMonth() + 1;

      const sameDay = dnStr => {
        if (!dnStr) return false;

        const parts = dnStr.split('-');
        if (parts.length !== 3) return false;

        const mes = parseInt(parts[1], 10);
        const dia = parseInt(parts[2], 10);

        const isMatch = dia === hojeDia && mes === hojeMes;

        return isMatch;
      };

      try {
        const res = await api.get('/signed/empresa/gestorprojeto/colaborador/aniversariantes');
        const lista = Array.isArray(res?.data) ? res.data : [];
        const hojeAniversariantes = lista
          .filter(p => {
            const dataNasc = p?.dataNascimento || p?.data_nascimento || p?.dob;
            return sameDay(dataNasc);
          })
          .map(p => ({
            id: p.id,
            nome: p.nome || p.name,
            dataNascimento: p.dataNascimento || p.data_nascimento || p.dob,
            fotoUrl:
              p.fotoUrl ||
              p.foto ||
              p.avatar ||
              p.imagem ||
              p.imageUrl ||
              p.profilePhotoUrl ||
              null,
          }));

        setBirthdaysToday(hojeAniversariantes);
      } catch (error) {
        console.error('Erro ao carregar aniversariantes:', error);
      }
    }

    async function loadComunicados() {
      try {
        const response = await api.get('/signed/empresa/gestorprojeto/comunicado/ativos');
        if (response?.data) {
          const destaque = response.data.filter(com => com.destaque === true);
          const outros = response.data.filter(com => com.destaque === false);

          setComunicadosDestaque(destaque);
          setTodosComunicados(outros);
        }
      } catch (error) {
        console.error('Erro ao carregar comunicados:', error);
      }
    }

    async function loadAll() {
      setLoading(true);
      await Promise.all([loadAniversariantes(), loadComunicados()]);
      setLoading(false);
    }

    loadAll();
  }, [usuario]);

  const handleOpenComunicado = comunicado => {
    const comunicadoFormatado = {
      ...comunicado,
      links:
        typeof comunicado.links === 'string'
          ? JSON.parse(comunicado.links)
          : Array.isArray(comunicado.links)
          ? comunicado.links
          : [],
    };
    setComunicadoSelecionado(comunicadoFormatado);
    setModalVisualizar(true);

    if (comunicado?.id) {
      api
        .post('/signed/empresa/gestorprojeto/comunicado/view', { id: comunicado.id })
        .catch(() => {});
    }
  };

  const handleCloseComunicado = () => {
    setModalVisualizar(false);
    setComunicadoSelecionado(null);
  };

  const handleMarcarComoLido = async comunicado => {
    try {
      if (comunicado?.id) {
        await api.post(`/signed/empresa/gestorprojeto/comunicado/${comunicado.id}/marcar-lido`);
      }
      const newTodosComunicados = todosComunicados.map(c =>
        c.id === comunicado?.id ? { ...c, lido: true } : c,
      );
      const newComunicadosDestaque = comunicadosDestaque.map(c =>
        c.id === comunicado?.id ? { ...c, lido: true } : c,
      );

      setTodosComunicados(newTodosComunicados);
      setComunicadosDestaque(newComunicadosDestaque);

      const allComunicados = [...newTodosComunicados, ...newComunicadosDestaque];
      const hasUnread = allComunicados.some(c => !c.lido);
      setHasUnreadComunicados?.(hasUnread);
    } catch (error) {
      console.warn('Falha ao marcar como lido:', error);
    } finally {
      handleCloseComunicado();
    }
  };

  // const extractTextFromHTML = htmlString => {
  //   if (!htmlString) return '';
  //   const tempDiv = document.createElement('div');
  //   tempDiv.innerHTML = htmlString;
  //   return tempDiv.textContent || tempDiv.innerText || '';
  // };

  return (
    <Container>
      <Header>
        <div>
          <HeaderTitle>
            {saudacao}, {firstName}!
          </HeaderTitle>
          <p
            style={{
              margin: 0,
              fontSize: '0.9rem',
              opacity: 0.7,
              color: Colors?.text_Color_1,
            }}
          >
            Bem-vindo ao Portal da empresa Erpworks.
          </p>
        </div>
        <HeaderDate>{hojeStr}</HeaderDate>
      </Header>

      {birthdaysToday.length > 0 && (
        <div
          style={{
            marginTop: '0.5rem',
            marginBottom: '1.25rem',
            background: 'linear-gradient(135deg, #BBDEFB 0%, #1E88E5 100%)',
            borderRadius: '14px',
            padding: '1.25rem',
            color: '#1f1f1f',
            boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <CakeIcon>🎂</CakeIcon>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '1.15rem',
                  lineHeight: 1.2,
                  color: '#222',
                  marginBottom: 4,
                }}
              >
                {(() => {
                  const count = birthdaysToday.length;
                  const first = birthdaysToday[0]?.nome || '';
                  const second = birthdaysToday[1]?.nome || '';
                  if (count === 1) return `Parabéns, ${first}! 🎉`;
                  if (count === 2) return `Parabéns, ${first} e ${second}! 🎉`;
                  return 'Parabéns aos aniversariantes! 🎉';
                })()}
              </div>
              <div style={{ opacity: 0.9, color: '#2b2b2b' }}>
                {(() => {
                  const count = birthdaysToday.length;
                  if (count === 1)
                    return 'A empresa deseja um dia incrível, repleto de saúde, conquistas e muitas felicidades!';
                  if (count === 2) return '';
                  // return 'Desejamos um dia incrível para vocês, com muita saúde, conquistas e muitas felicidades';
                  return '';
                  // return 'A empresa deseja um dia incrível para todos, com muita saúde, conquistas e muitas felicidades';
                })()}
              </div>
            </div>
            <div>
              <span
                style={{
                  display: 'inline-block',
                  background: 'rgba(255,255,255,0.7)',
                  color: '#333',
                  padding: '0.4rem 0.7rem',
                  borderRadius: '999px',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
              >
                Feliz Aniversário 💙
              </span>
            </div>
          </div>

          {birthdaysToday.length > 1 && (
            <div style={{ marginTop: '0.9rem', display: 'grid', gap: '0.8rem' }}>
              {birthdaysToday.slice(0, 3).map(pessoa => {
                const nome = pessoa?.nome || '';
                return (
                  <div
                    key={pessoa.id}
                    style={{
                      background: 'rgba(255,255,255,0.85)',
                      borderRadius: 12,
                      padding: '0.8rem',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                      <img
                        src={pessoa?.fotoUrl || IconAvatarChat}
                        alt={pessoa?.nome || 'Aniversariante'}
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '2px solid rgba(0,0,0,0.05)',
                          background: 'rgba(255,255,255,0.8)',
                        }}
                        onError={e => {
                          e.currentTarget.src = IconAvatarChat;
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: 700, color: '#1f1f1f' }}>
                          {`Parabéns, ${nome}! 🎉`}
                        </div>
                        <div style={{ fontSize: '0.9rem', opacity: 0.9, color: '#2b2b2b' }}>
                          {
                            'A empresa deseja um dia incrível, repleto de saúde, conquistas e muitas felicidades'
                          }
                          !
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {(loading || comunicadosDestaque.length > 0) && (
        <Section>
          <SectionHeaderRow>
            <SectionTitle>
              <TitleDot />
              Comunicados em Destaque
            </SectionTitle>
          </SectionHeaderRow>

          <CardsGrid>
            {loading
              ? Array.from({ length: 2 }).map((_, idx) => (
                  <SkeletonCard key={idx}>
                    <div
                      className="skeleton"
                      style={{ height: 24, width: '60%', marginBottom: '1rem' }}
                    />
                    <div
                      className="skeleton"
                      style={{ height: 16, width: '100%', marginBottom: '0.5rem' }}
                    />
                    <div
                      className="skeleton"
                      style={{ height: 16, width: '100%', marginBottom: '0.5rem' }}
                    />
                    <div
                      className="skeleton"
                      style={{ height: 16, width: '80%', marginBottom: '1rem' }}
                    />
                    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
                      <div className="skeleton" style={{ height: 24, width: 80 }} />
                      <div className="skeleton" style={{ height: 24, width: 80 }} />
                    </div>
                    <div
                      className="skeleton"
                      style={{ height: 16, width: '40%', marginTop: 'auto' }}
                    />
                  </SkeletonCard>
                ))
              : comunicadosDestaque.map(comunicado => {
                  return (
                    <ComunicadoItemContainer key={comunicado.id}>
                      {!comunicado.lido && <UnreadIndicator />}
                      <ComunicadoCard destaque onClick={() => handleOpenComunicado(comunicado)}>
                        <DestaqueBadge />
                        <CardHeader>
                          <CardTitle>{comunicado.titulo}</CardTitle>
                        </CardHeader>

                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                          }}
                        >
                          <CardDescription
                            dangerouslySetInnerHTML={{ __html: comunicado.conteudo }}
                          />

                          {(() => {
                            const linksArray =
                              typeof comunicado.links === 'string'
                                ? JSON.parse(comunicado.links || '[]')
                                : comunicado.links || [];
                            const hasLinks = linksArray.length > 0;
                            const hasAnexos = comunicado.anexos?.length > 0;

                            // Texto da label de link: host do primeiro link ou fallback
                            let linkLabelText = 'Sem links';
                            if (hasLinks) {
                              const first = linksArray[0];
                              const raw =
                                typeof first === 'string'
                                  ? first
                                  : first?.url || first?.link || first?.titulo || '';
                              try {
                                const u = new URL(raw);
                                linkLabelText = u.host;
                              } catch (e) {
                                linkLabelText = raw || '1 link';
                              }
                            }

                            return (
                              <div
                                style={{
                                  marginTop: '0.5rem',
                                  marginBottom: '1rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.7em',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.35em',
                                    fontSize: '0.7em',
                                    padding: '0.35em 0.6em',
                                    borderRadius: '0.4em',
                                    background: hasLinks ? Colors.Color8 : 'transparent',
                                    color: hasLinks ? Colors.Color4 : Colors.Color6,
                                  }}
                                >
                                  <i
                                    className="material-icons"
                                    style={{
                                      fontSize: '1em',
                                      color: hasLinks ? Colors.Color4 : Colors.Color6,
                                    }}
                                  >
                                    link
                                  </i>
                                  <span
                                    style={{
                                      maxWidth: '100px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {linkLabelText}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.35em',
                                    fontSize: '0.7em',
                                    padding: '0.35em 0.6em',
                                    borderRadius: '0.4em',
                                    background: hasAnexos ? Colors.Color8 : 'transparent',
                                    color: hasAnexos ? Colors.Color4 : Colors.Color6,
                                  }}
                                >
                                  <i
                                    className="material-icons"
                                    style={{
                                      fontSize: '1em',
                                      color: hasAnexos ? Colors.Color4 : Colors.Color6,
                                    }}
                                  >
                                    insert_drive_file
                                  </i>
                                  <span>
                                    {hasAnexos
                                      ? `${comunicado.anexos.length} ${
                                          comunicado.anexos.length === 1 ? 'anexo' : 'anexos'
                                        }`
                                      : 'Sem anexos'}
                                  </span>
                                </div>
                              </div>
                            );
                          })()}
                        </div>

                        {/* <TagsContainer> */}

                        <CardFooter>
                          <DateInfo>
                            <i
                              className="material-icons"
                              style={{ fontSize: '1rem', marginRight: '0.25rem' }}
                            >
                              calendar_today
                            </i>
                            {new Date(comunicado.dataCadastro).toLocaleDateString('pt-BR')}
                          </DateInfo>
                          {comunicado.lido ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.35rem',
                                color: Colors.Color4,
                                fontSize: '0.85rem',
                                fontWeight: '500',
                              }}
                            >
                              <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                                check_circle
                              </i>
                              Visualizado
                            </div>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.35rem',
                                color: Colors.Color6,
                                fontSize: '0.85rem',
                                fontWeight: '500',
                              }}
                            >
                              <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                                radio_button_unchecked
                              </i>
                              Não visualizado
                            </div>
                          )}
                        </CardFooter>
                      </ComunicadoCard>
                    </ComunicadoItemContainer>
                  );
                })}
          </CardsGrid>
        </Section>
      )}

      <Section>
        <SectionTitle>
          <TitleDot />
          Todos os Comunicados
        </SectionTitle>

        <ComunicadosList>
          {loading ? (
            Array.from({ length: 6 }).map((_, idx) => (
              <SkeletonItem key={idx}>
                <div
                  className="skeleton"
                  style={{ height: 20, width: '70%', marginBottom: '1rem' }}
                />
                <div
                  className="skeleton"
                  style={{ height: 14, width: '100%', marginBottom: '0.5rem' }}
                />
                <div
                  className="skeleton"
                  style={{ height: 14, width: '100%', marginBottom: '0.5rem' }}
                />
                <div
                  className="skeleton"
                  style={{ height: 14, width: '90%', marginBottom: '1rem' }}
                />
                <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
                  <div className="skeleton" style={{ height: 20, width: 60 }} />
                  <div className="skeleton" style={{ height: 20, width: 60 }} />
                </div>
                <div className="skeleton" style={{ height: 14, width: '30%' }} />
              </SkeletonItem>
            ))
          ) : todosComunicados.length === 0 ? (
            <>
              <div></div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    textAlign: 'center',
                    padding: '3rem 1rem',
                    color: Colors.text_Color_1,
                    opacity: 0.6,
                  }}
                >
                  <i
                    className="material-icons"
                    style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.3 }}
                  >
                    info_outline
                  </i>
                  <p style={{ fontSize: '1.1rem', fontWeight: 500, margin: 0 }}>
                    Não há comunicados disponíveis no momento
                  </p>
                </div>
              </div>
            </>
          ) : (
            todosComunicados.map(comunicado => {
              return (
                <ComunicadoItemContainer key={comunicado.id}>
                  {/* Indicador de não lido - aparece apenas se não foi lido */}
                  {!comunicado.lido && <UnreadIndicator />}
                  <ComunicadoItem onClick={() => handleOpenComunicado(comunicado)}>
                    <ItemContent>
                      <ItemHeader>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.4rem',
                            flex: 1,
                          }}
                        >
                          <ItemTitle>{comunicado.titulo}</ItemTitle>
                        </div>
                      </ItemHeader>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          height: '100%',
                        }}
                      >
                        <ItemDescription
                          dangerouslySetInnerHTML={{ __html: comunicado.conteudo }}
                        />

                        {(() => {
                          const linksArray =
                            typeof comunicado.links === 'string'
                              ? JSON.parse(comunicado.links || '[]')
                              : comunicado.links || [];
                          const hasLinks = linksArray.length > 0;
                          const hasAnexos = comunicado.anexos?.length > 0;

                          // Texto da label de link: host do primeiro link ou fallback
                          let linkLabelText = 'Sem links';
                          if (hasLinks) {
                            const first = linksArray[0];
                            const raw =
                              typeof first === 'string'
                                ? first
                                : first?.url || first?.link || first?.titulo || '';
                            try {
                              const u = new URL(raw);
                              linkLabelText = u.host;
                            } catch (e) {
                              linkLabelText = raw || '1 link';
                            }
                          }

                          return (
                            <div
                              style={{
                                marginTop: '0.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.7em',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.35em',
                                  fontSize: '0.7em',
                                  padding: '0.35em 0.6em',
                                  borderRadius: '0.4em',
                                  background: hasLinks ? Colors.Color8 : 'transparent',
                                  color: hasLinks ? Colors.Color4 : Colors.Color6,
                                }}
                              >
                                <i className="material-icons" style={{ fontSize: '1em' }}>
                                  link
                                </i>
                                <span
                                  style={{
                                    maxWidth: '100px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {linkLabelText}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.35em',
                                  fontSize: '0.7em',
                                  padding: '0.35em 0.6em',
                                  borderRadius: '0.4em',
                                  background: hasAnexos ? Colors.Color8 : 'transparent',
                                  color: hasAnexos ? Colors.Color4 : Colors.Color6,
                                }}
                              >
                                <i className="material-icons" style={{ fontSize: '1em' }}>
                                  insert_drive_file
                                </i>
                                <span>
                                  {hasAnexos
                                    ? `${comunicado.anexos.length} ${
                                        comunicado.anexos.length === 1 ? 'anexo' : 'anexos'
                                      }`
                                    : 'Sem anexos'}
                                </span>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                    </ItemContent>

                    <ItemFooter>
                      <DateInfo>
                        <i
                          className="material-icons"
                          style={{ fontSize: '1rem', marginRight: '0.25rem' }}
                        >
                          calendar_today
                        </i>
                        {new Date(comunicado.dataCadastro).toLocaleDateString('pt-BR')}
                      </DateInfo>
                      {comunicado.lido ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.35rem',
                            color: Colors.Color4,
                            fontSize: '0.85rem',
                            fontWeight: '500',
                          }}
                        >
                          <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                            check_circle
                          </i>
                          Visualizado
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.35rem',
                            color: Colors.Color6,
                            fontSize: '0.85rem',
                            fontWeight: '500',
                          }}
                        >
                          <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                            radio_button_unchecked
                          </i>
                          Não visualizado
                        </div>
                      )}
                    </ItemFooter>
                  </ComunicadoItem>
                </ComunicadoItemContainer>
              );
            })
          )}
        </ComunicadosList>
      </Section>

      {/* Modal para visualizar comunicado */}
      <Modal
        isOpen={modalVisualizar}
        onRequestClose={handleCloseComunicado}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 9999,
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: 'none',
            borderRadius: '12px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '90vh',
          },
        }}
      >
        {comunicadoSelecionado && (
          <ModalContent>
            {/* Header com título e data */}
            <ModalHeader>
              <ModalTitle>Comunicado</ModalTitle>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <DateInfo>
                  <i
                    className="material-icons"
                    style={{ fontSize: '1rem', marginRight: '0.25rem' }}
                  >
                    calendar_today
                  </i>
                  {new Date(comunicadoSelecionado.dataCadastro).toLocaleDateString('pt-BR')}
                </DateInfo>
                <ModalCloseButton onClick={handleCloseComunicado}>✕</ModalCloseButton>
              </div>
            </ModalHeader>

            {/* Corpo com conteúdo formatado e seções auxiliares */}
            <ModalBody>
              <ModalTitle
                style={{
                  color: Colors.Color9,
                  marginBottom: '1rem',
                }}
              >
                {comunicadoSelecionado.titulo}
              </ModalTitle>

              <div
                style={{
                  lineHeight: '1.6',
                }}
                dangerouslySetInnerHTML={{ __html: comunicadoSelecionado.conteudo }}
              />

              {/* Seção de links úteis */}
              {comunicadoSelecionado.links &&
                Array.isArray(comunicadoSelecionado.links) &&
                comunicadoSelecionado.links.length > 0 && (
                  <div style={{ marginTop: '1rem' }}>
                    <strong style={{ display: 'block', marginBottom: '0.5rem' }}>
                      Links úteis
                    </strong>
                    <ul
                      style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        display: 'grid',
                        gap: '0.5rem',
                      }}
                    >
                      {comunicadoSelecionado.links.map((link, index) => {
                        // Suporta tanto string quanto objeto {url: "..."}
                        const linkUrl = typeof link === 'string' ? link : link?.url || '';
                        if (!linkUrl) return null;
                        return (
                          <li
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem',
                              minWidth: 0,
                            }}
                          >
                            <span
                              style={{
                                fontSize: '0.8rem',
                                flexShrink: 0,
                              }}
                            >
                              🔗
                            </span>
                            <a
                              href={linkUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: '1rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                textDecoration: 'underline',
                              }}
                            >
                              {linkUrl}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

              {/* Seção de anexo para download */}
              {comunicadoSelecionado.anexos && comunicadoSelecionado.anexos.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Anexo</strong>
                  {comunicadoSelecionado.anexos.map((anexoItem, index) => {
                    const arquivo = anexoItem.arquivo;
                    if (!arquivo) return null;

                    const arquivoUrl = arquivo.url;
                    const nomeArquivo = arquivo.fileOldName || arquivo.fileName || 'Arquivo';
                    const tamanhoMB = arquivo.tamanho
                      ? (arquivo.tamanho / (1024 * 1024)).toFixed(2)
                      : null;

                    // Verificar se é uma imagem
                    const extensao = (arquivo.ext || '').toLowerCase();
                    const isImage = [
                      '.png',
                      '.jpg',
                      '.jpeg',
                      '.gif',
                      '.webp',
                      '.bmp',
                      '.svg',
                    ].includes(extensao);

                    // Se for imagem, exibir a imagem
                    if (isImage && arquivoUrl) {
                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginBottom:
                              index < comunicadoSelecionado.anexos.length - 1 ? '1rem' : 0,
                          }}
                        >
                          <img
                            src={arquivoUrl}
                            alt={nomeArquivo}
                            style={{
                              maxWidth: '100%',
                              // maxHeight: '400px',
                              borderRadius: '8px',
                              objectFit: 'contain',
                              cursor: 'pointer',
                              border: `1px solid ${Colors.Color6}20`,
                            }}
                            onClick={() => window.open(arquivoUrl, '_blank')}
                            title="Clique para abrir em tamanho original"
                          />
                          {/* <p
                            style={{
                              fontSize: '0.85rem',
                              color: Colors.text_Color_1,
                              opacity: 0.7,
                              marginTop: '0.5rem',
                              marginBottom: 0,
                            }}
                          >
                            {nomeArquivo} {tamanhoMB && `(${tamanhoMB} MB)`}
                          </p> */}
                        </div>
                      );
                    }

                    // Se não for imagem, exibir como arquivo para download
                    return (
                      <FilePreview
                        key={index}
                        style={{
                          marginBottom:
                            index < comunicadoSelecionado.anexos.length - 1 ? '0.5rem' : 0,
                        }}
                      >
                        <FilePreviewIcon>📄</FilePreviewIcon>
                        <FilePreviewInfo>
                          <FilePreviewName>{nomeArquivo}</FilePreviewName>
                          {tamanhoMB && <FilePreviewSize>{tamanhoMB} MB</FilePreviewSize>}
                        </FilePreviewInfo>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <DownloadButton
                            type="button"
                            onClick={() => {
                              if (arquivoUrl) window.open(arquivoUrl, '_blank');
                            }}
                            title="Visualizar em nova aba"
                          >
                            Visualizar
                          </DownloadButton>
                        </div>
                      </FilePreview>
                    );
                  })}
                </div>
              )}
            </ModalBody>

            {/* Rodapé com ações */}
            <ModalFooter>
              <ModalButton secondary type="button" onClick={handleCloseComunicado}>
                Fechar
              </ModalButton>
              <ModalButton
                type="button"
                onClick={() => handleMarcarComoLido(comunicadoSelecionado)}
                style={{ position: 'relative' }}
              >
                {!comunicadoSelecionado.lido && <UnreadIndicator />}
                Marcar como lido
              </ModalButton>
            </ModalFooter>
          </ModalContent>
        )}
      </Modal>
    </Container>
  );
}
